<template>
  <div>
    <div class="action_viewer_ar_product__box">
      <template v-if="isPersonalizedArMode">
        <button
          v-if="showRoom"
          @click="handleClickRoomPersonalized"
          class="action_viewer_ar_product__box_btn"
          :class="{'open': openImg}"
          :disabled="generatingRoom || generatingAr"
        >
          <span v-if="generatingRoom" class="ar_personalized_spinner"></span>
          <span v-else-if="!openImg">VIEW IN MY ROOM</span>
          <v-icon
            v-else
            style="width: 23px"
            name="x"
          ></v-icon>
        </button>

        <button
          v-if="show360"
          @click="handleClickArPersonalized"
          class="action_viewer_ar_product__box_btn"
          :class="{'open': open3d}"
          :disabled="generatingRoom || generatingAr"
        >
          <span v-if="generatingAr" class="ar_personalized_spinner"></span>
          <svg style="width: 39px;" v-else-if="!open3d" viewBox="0 0 40 21" xmlns="http://www.w3.org/2000/svg"><g fill="#333"><path d="M11.66 11.887c-1.168 0-2.152-.374-2.64-.694l-.204-.133.562-1.592.33.21c.297.19 1.085.551 1.938.551.634 0 1.119-.165 1.44-.493a1.44 1.44 0 0 0 .398-1.033c-.013-1.177-1.117-1.595-2.146-1.595h-1.026V5.523h1.026c.728 0 1.81-.346 1.81-1.298 0-.713-.495-1.122-1.356-1.122-.68 0-1.351.307-1.72.57l-.333.239-.554-1.54.187-.136c.535-.394 1.568-.791 2.668-.791 2.092 0 3.029 1.293 3.029 2.575 0 .92-.454 1.692-1.267 2.196 1.012.458 1.632 1.383 1.632 2.51 0 1.574-1.167 3.16-3.774 3.16zm15.587 0c-2.1 0-3.423-1.988-3.452-5.189 0-1.595.34-2.923.984-3.845.643-.92 1.552-1.407 2.629-1.407 2.162 0 3.452 1.913 3.452 5.118 0 3.383-1.317 5.324-3.613 5.324zm.088-8.827c-.992 0-1.634 1.433-1.634 3.65 0 2.218.62 3.563 1.62 3.563 1.42 0 1.633-2.288 1.633-3.65 0-1.364-.21-3.563-1.62-3.563zm-7.107 1.79c-.658 0-1.274.181-1.786.516.463-1.165 1.46-1.956 2.799-2.18.244-.038.493-.06.72-.06.062 0 .122.003.18.006l.326.017V1.46h-.31c-.323 0-.654.027-.972.076-1.272.154-2.385.67-3.222 1.491-1.095 1.096-1.698 2.694-1.698 4.501 0 2.649 1.44 4.36 3.671 4.36 2.23 0 3.467-1.885 3.467-3.659 0-1.99-1.306-3.379-3.174-3.379v.001zm-.247 5.254c-.972 0-1.76-.88-1.76-1.966s.788-1.966 1.76-1.966c.97 0 1.758.88 1.758 1.966 0 1.085-.787 1.966-1.758 1.966z"></path><path d="M3.08 12.846c0-.985 1.872-1.876 4.9-2.522l.348-.99c-4.783.924-7.887 2.407-7.887 4.08 0 2.534 7.11 4.633 16.398 5.01v-2.066c-7.825-.301-13.76-1.76-13.76-3.513zm36.156.569c0-1.651-3.021-3.118-7.697-4.043a6.7 6.7 0 0 1-.306.857c3.3.651 5.364 1.583 5.364 2.617 0 1.934-7.225 3.509-16.242 3.567v2.07c10.474-.073 18.88-2.314 18.88-5.068z"></path><path d="M15.39 20.76l3.931-3.259-3.931-3.259zM33.236.24a2.018 2.018 0 1 0 0 4.035 2.018 2.018 0 0 0 0-4.035zm0 3a.983.983 0 1 1 0-1.965.983.983 0 0 1 0 1.965z"></path></g></svg>
          <v-icon
            v-else
            style="width: 23px"
            name="x"
          ></v-icon>
        </button>

        <div class="ar_personalized_error" v-if="personalizedError">{{ personalizedError }}</div>
      </template>

      <template v-else>
        <button
          @click="handleToggleViewImage"
          class="action_viewer_ar_product__box_btn view_in_room"
          :class="{'open': openImg}"
          v-if="urlIMG && showRoom"
        >
          <span v-if="!openImg">VIEW IN MY ROOM</span>
          <v-icon
            v-else
            style="width: 23px"
            name="x"
          ></v-icon>
        </button>
        <a class="link_3d_mobile" v-if="link_3d_mobile && showRoom" :href="link_3d_mobile" target="_blank">
          <button
            class="action_viewer_ar_product__box_btn"
          >
            VIEW IN MY ROOM
          </button>
        </a>

        <button
          v-if="urlGLT && show360"
          @click="handleToggleViewAR"
          class="action_viewer_ar_product__box_btn"
          :class="{'open': open3d}"
        >
          <svg style="width: 39px;" v-if="!open3d" viewBox="0 0 40 21" xmlns="http://www.w3.org/2000/svg"><g fill="#333"><path d="M11.66 11.887c-1.168 0-2.152-.374-2.64-.694l-.204-.133.562-1.592.33.21c.297.19 1.085.551 1.938.551.634 0 1.119-.165 1.44-.493a1.44 1.44 0 0 0 .398-1.033c-.013-1.177-1.117-1.595-2.146-1.595h-1.026V5.523h1.026c.728 0 1.81-.346 1.81-1.298 0-.713-.495-1.122-1.356-1.122-.68 0-1.351.307-1.72.57l-.333.239-.554-1.54.187-.136c.535-.394 1.568-.791 2.668-.791 2.092 0 3.029 1.293 3.029 2.575 0 .92-.454 1.692-1.267 2.196 1.012.458 1.632 1.383 1.632 2.51 0 1.574-1.167 3.16-3.774 3.16zm15.587 0c-2.1 0-3.423-1.988-3.452-5.189 0-1.595.34-2.923.984-3.845.643-.92 1.552-1.407 2.629-1.407 2.162 0 3.452 1.913 3.452 5.118 0 3.383-1.317 5.324-3.613 5.324zm.088-8.827c-.992 0-1.634 1.433-1.634 3.65 0 2.218.62 3.563 1.62 3.563 1.42 0 1.633-2.288 1.633-3.65 0-1.364-.21-3.563-1.62-3.563zm-7.107 1.79c-.658 0-1.274.181-1.786.516.463-1.165 1.46-1.956 2.799-2.18.244-.038.493-.06.72-.06.062 0 .122.003.18.006l.326.017V1.46h-.31c-.323 0-.654.027-.972.076-1.272.154-2.385.67-3.222 1.491-1.095 1.096-1.698 2.694-1.698 4.501 0 2.649 1.44 4.36 3.671 4.36 2.23 0 3.467-1.885 3.467-3.659 0-1.99-1.306-3.379-3.174-3.379v.001zm-.247 5.254c-.972 0-1.76-.88-1.76-1.966s.788-1.966 1.76-1.966c.97 0 1.758.88 1.758 1.966 0 1.085-.787 1.966-1.758 1.966z"></path><path d="M3.08 12.846c0-.985 1.872-1.876 4.9-2.522l.348-.99c-4.783.924-7.887 2.407-7.887 4.08 0 2.534 7.11 4.633 16.398 5.01v-2.066c-7.825-.301-13.76-1.76-13.76-3.513zm36.156.569c0-1.651-3.021-3.118-7.697-4.043a6.7 6.7 0 0 1-.306.857c3.3.651 5.364 1.583 5.364 2.617 0 1.934-7.225 3.509-16.242 3.567v2.07c10.474-.073 18.88-2.314 18.88-5.068z"></path><path d="M15.39 20.76l3.931-3.259-3.931-3.259zM33.236.24a2.018 2.018 0 1 0 0 4.035 2.018 2.018 0 0 0 0-4.035zm0 3a.983.983 0 1 1 0-1.965.983.983 0 0 1 0 1.965z"></path></g></svg>
          <v-icon
            v-else
            style="width: 23px"
            name="x"
          ></v-icon>
        </button>
      </template>
    </div>

    <div v-if="isPersonalizedArMode && (generatingRoom || generatingAr)" class="ar_generating_overlay">
      <div class="ar_generating_overlay__animation">
        <span class="ar_generating_overlay__frame">🖼️</span>
        <span class="ar_generating_overlay__sparkle">✨</span>
      </div>
      <transition name="ar_fade" mode="out-in">
        <div class="ar_generating_overlay__text" :key="loadingMessageIndex">{{ loadingMessages[loadingMessageIndex] }}</div>
      </transition>
      <div class="ar_generating_overlay__dots">
        <span></span><span></span><span></span>
      </div>
    </div>

    <div v-if="open3d" class="model-viewer-container threed" :style="threedBackgroundStyle">
      <ModelViewerAr v-if="loadJs && urlGLT" :url="urlGLT" />
    </div>
    <div v-if="openImg" class="model-viewer-container" :style="roomBackgroundStyle">
      <img class="model-viewer-container__image_ar_qr" :src="urlIMG" />
    </div>
    <div
      v-if="isPersonalizedArMode && currentArtwork && captureStageActive"
      style="position: fixed; top: -999999px; left: -999999px; pointer-events: none;"
    >
      <v-stage ref="captureStage" :config="captureStageConfig">
        <v-layer>
          <artwork-preview
            :artwork="currentArtwork"
            :width="captureArtworkWidth"
          />
        </v-layer>
      </v-stage>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ModelViewerAr from '../Utilities/ModelViewerAr.vue';
import ArtworkPreview from '../PreviewArtwork/ArtworkPreview.vue';
import { AR_SERVICE_URL, AR_SERVICE_API_KEY } from '@/config';

const MAX_CAPTURE_DIMENSION = 2000;
const GENERATING_MESSAGES = [
  'Snapping a photo of your artwork...',
  'Measuring your virtual wall...',
  'Hanging it up to take a look...',
  'Building the AR model, almost there...',
  'Adjusting the lighting just right...',
  'Wrapping up your 3D preview...'
];
const GENERATING_MESSAGE_INTERVAL_MS = 1800;
const AR_REQUEST_TIMEOUT_MS = 60000;
const CAPTURE_IMAGE_TIMEOUT_MS = 15000;

// Lỗi chi tiết chỉ ghi console; khách chỉ thấy thông báo dễ hiểu.
function friendlyArErrorMessage(err) {
  console.error('[AR]', err);
  if (err && err.isTimeout) {
    return 'This is taking longer than usual. Please try again in a moment.';
  }
  return "Sorry, we couldn't create your preview right now. Please try again in a moment.";
}

function parseSizeLabel(label) {
  const match = String(label || '').match(/(\d+(?:\.\d+)?)\s*[xX]\s*(\d+(?:\.\d+)?)/);
  if (!match) {
    return null;
  }
  return { w: Number(match[1]), h: Number(match[2]) };
}

function isMobileDevice() {
  return /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
}

// Mở trang chờ /preparing của dịch vụ AR (thay cho tab about:blank trắng);
// có kết quả thì applyRoomResult đổi location của chính tab này sang viewUrl.
// KHÔNG gán popup.opener = null: tab đã sang origin khác (ar.oopprint.com),
// cắt opener thì trình duyệt chặn đổi location (SecurityError "does not have
// permission to navigate the target frame"). Opener chỉ lộ cho domain AR của mình.
function openPendingArWindow() {
  return window.open(AR_SERVICE_URL + '/preparing', '_blank') || null;
}

function closeWindow(popup) {
  if (popup && !popup.closed) {
    popup.close();
  }
}

// ornament
const ORNAMENT_SIZE = '3.2x3.2';

// ornament material
const ORNAMENT_MATERIAL_SKU_RULES = [
  { needle: 'orn-heart', material: 'ceramicHeart' },
  { needle: 'orn-circle', material: 'ceramic' },
  { needle: 'glso', material: 'glass' },
  { needle: 'waw', material: 'wood' }
];

function detectOrnamentMaterialFromSku(sku) {
  const lower = String(sku || '').toLowerCase();
  const rule = ORNAMENT_MATERIAL_SKU_RULES.find(r => lower.includes(r.needle));
  return rule ? rule.material : null;
}

// MUG SIZE
const MUG_SIZE = '11oz';
const TEXT_LAYER_READY_DELAY_MS = 1200;

// jewelry_dish
const JEWELRY_DISH_VARIANT_SKU_MARKER = 'tdish-1';
const JEWELRY_DISH_SHAPE_KEYWORDS = [
  { needle: 'round', shape: 'round' },
  { needle: 'square', shape: 'square' },
  { needle: 'heart', shape: 'heart' }
];

function detectJewelryDishShapeFromVariants(variants) {
  if (!Array.isArray(variants)) {
    return null;
  }
  for (const variant of variants) {
    const lower = String((variant && variant.sku) || '').toLowerCase();
    if (!lower.includes(JEWELRY_DISH_VARIANT_SKU_MARKER)) {
      continue;
    }
    const rule = JEWELRY_DISH_SHAPE_KEYWORDS.find(r => lower.includes(r.needle));
    if (rule) {
      return rule.shape;
    }
  }
  return null;
}

// pillow — shape isn't a fixed SKU keyword like the others above: derived by
// comparing the WxH size parsed out of the variant's own sku (e.g.
// "...-Pillow-13x21..."). Equal width/height -> square, anything else
// (narrower or wider than tall) -> rectangle.
const PILLOW_VARIANT_SKU_MARKER = 'pillow';

function detectPillowShapeFromVariants(variants) {
  if (!Array.isArray(variants)) {
    return null;
  }
  for (const variant of variants) {
    const lower = String((variant && variant.sku) || '').toLowerCase();
    if (!lower.includes(PILLOW_VARIANT_SKU_MARKER)) {
      continue;
    }
    const parsed = parseSizeLabel(lower);
    if (!parsed) {
      continue;
    }
    return parsed.w === parsed.h ? 'square' : 'rectangle';
  }
  return null;
}

// ceramic_tile
const STONE_SKU_RULES = [
  { needle: 'st-heart', shape: 'heart' },
  { needle: 'st-rect', shape: 'rectangle' },
  { needle: 'st-round', shape: 'round' },
  { needle: 'st-square', shape: 'square' }
];

function detectStoneShapeFromSku(sku) {
  const lower = String(sku || '').toLowerCase();
  const rule = STONE_SKU_RULES.find(r => lower.includes(r.needle));
  return rule ? rule.shape : null;
}

const CERAMIC_TILE_SKU_RULES = [
  { needle: 'sct-wf-square', shape: 'square' },
  { needle: 'sct-wf-round', shape: 'round' },
  { needle: 'sct-wf-rect', shape: 'rectangle' },
  { needle: 'sct-wf-heart', shape: 'heart' }
];

function detectCeramicTileShapeFromSku(sku) {
  const lower = String(sku || '').toLowerCase();
  const rule = CERAMIC_TILE_SKU_RULES.find(r => lower.includes(r.needle));
  return rule ? rule.shape : null;
}

// Bamboo Cutting Board is detected from the parent product's own sku (never
// a variant's) — a single fixed shape/size, no shape sub-choice at all.
const BAMBOO_CUTTING_BOARD_SKU_MARKER = 'bcb1';
// Mirrors admin.js's own hardcoded ['16x11'] placeholder — the AR service
// ignores this field for Bamboo Cutting Board, it just needs to be non-empty.
const BAMBOO_CUTTING_BOARD_SIZE = '16x11';

// Acrylic Plaque is also detected from the parent product's own sku — mirrors
// abnviewer_ar_acrylic_plaque_shapes().
const ACRYLIC_PLAQUE_SKU_RULES = [
  { needle: 'h-acrylic', shape: 'heart' },
  { needle: 'adesk', shape: '8x2.5' },
  { needle: 'a-square', shape: 'square' },
  { needle: 'a-ver', shape: '4x6' },
  { needle: 'pp-acrylic', shape: 'puzzle' },
  { needle: 'a-ret', shape: '7x5' }
];

function detectAcrylicPlaqueShapeFromSku(sku) {
  const lower = String(sku || '').toLowerCase();
  const rule = ACRYLIC_PLAQUE_SKU_RULES.find(r => lower.includes(r.needle));
  return rule ? rule.shape : null;
}

// Blanket is detected from the parent product's own sku (never a variant's)
// containing "blanket" (case-insensitive). The AR service builds any WxH in
// inches (30x40, 50x60, 60x80, ...), so the selected variant's "Size" is sent
// as is; 30x40 (the service's own default) when no size is selected.
const BLANKET_SKU_MARKER = 'blanket';
const DEFAULT_BLANKET_SIZE = '30x40';

// JPEG gửi AR: server vẫn nén lại (q92) nên lấy cao hơn chút để không mất nét.
const AR_JPEG_QUALITY = 0.95;

function canvasToFile(canvas, filename, mimeType) {
  return new Promise((resolve, reject) => {
    canvas.toBlob(blob => {
      if (!blob) {
        reject(new Error('Could not encode the captured artwork image.'));
        return;
      }
      resolve(new File([blob], filename, { type: mimeType }));
    }, mimeType, mimeType === 'image/jpeg' ? AR_JPEG_QUALITY : undefined);
  });
}
// Ép nền trắng giống server (flatten #ffffff) — canvas JPEG để nguyên thì chỗ
// trong suốt thành màu đen.
function encodeArtworkFile(canvas, basename, asJpeg) {
  if (!asJpeg) {
    return canvasToFile(canvas, `${basename}.png`, 'image/png');
  }
  const flat = document.createElement('canvas');
  flat.width = canvas.width;
  flat.height = canvas.height;
  const ctx = flat.getContext('2d');
  ctx.fillStyle = '#ffffff';
  ctx.fillRect(0, 0, flat.width, flat.height);
  ctx.drawImage(canvas, 0, 0);
  return canvasToFile(flat, `${basename}.jpg`, 'image/jpeg');
}
function cropCanvas(canvas, x, width) {
  const out = document.createElement('canvas');
  out.width = width;
  out.height = canvas.height;
  out.getContext('2d').drawImage(canvas, x, 0, width, canvas.height, 0, 0, width, canvas.height);
  return out;
}
function splitCanvasInHalf(canvas) {
  const frontWidth = Math.floor(canvas.width / 2);
  return {
    front: cropCanvas(canvas, 0, frontWidth),
    back: cropCanvas(canvas, frontWidth, canvas.width - frontWidth)
  };
}
// Theo dõi ảnh của riêng stage ẩn (ImagePreview inject qua provide), không
// dùng imageLoadings của store: store đánh dấu theo file.key, trùng key với
// ảnh ở trang chính nên trang chính tải xong là stage ẩn bị coi như xong.
function createCaptureImageTracker() {
  let generation = 0;
  let pending = 0;
  let failures = [];
  return {
    reset() {
      generation++;
      pending = 0;
      failures = [];
    },
    begin() {
      const handleGeneration = generation;
      let settled = false;
      pending++;
      const settle = (failedSrc) => {
        if (settled || handleGeneration !== generation) {
          return;
        }
        settled = true;
        pending--;
        if (failedSrc !== undefined) {
          failures.push(failedSrc);
        }
      };
      return {
        done: () => settle(),
        fail: (src) => settle(String(src || '').slice(0, 200))
      };
    },
    state() {
      return { pending, failures };
    }
  };
}
// Ảnh lỗi hoặc quá hạn thì báo lỗi luôn — chụp tiếp sẽ ra AR thiếu ảnh.
function waitForCaptureImages(tracker, { timeoutMs = CAPTURE_IMAGE_TIMEOUT_MS, intervalMs = 100 } = {}) {
  return new Promise((resolve, reject) => {
    const start = Date.now();
    (function check() {
      const { pending, failures } = tracker.state();
      if (failures.length) {
        reject(new Error(`Artwork image failed to load: ${failures[0]}`));
        return;
      }
      if (!pending) {
        resolve();
        return;
      }
      if (Date.now() - start >= timeoutMs) {
        reject(new Error(`${pending} artwork image(s) still loading after ${timeoutMs}ms.`));
        return;
      }
      setTimeout(check, intervalMs);
    })();
  });
}

export default {
  name: 'LoadArThree',
  data() {
    return {
      open3d: false,
      openImg: false,
      urlGLT: "",
      urlIMG: "",
      link_3d_mobile: "",
      loadJs: false,
      modelViewerRequested: false,
      loading: false,
      generatingRoom: false,
      generatingAr: false,
      personalizedError: null,
      loadingMessages: GENERATING_MESSAGES,
      loadingMessageIndex: 0,
      loadingMessageTimer: null,
      personalizedCache: { signature: null, bySize: {} },
      personalizedInFlight: {},
      // Stage ẩn (artwork tới 2000px) chỉ dựng khi cần chụp — dựng ngay lúc
      // tải trang làm chậm trang sản phẩm ~1-2s dù khách chưa bấm AR.
      captureStageActive: false,
      captureStageUsers: 0,
      captureStageMountedAt: null
    }
  },
  props: {
    uuidAr: {
      type: String,
      default(){
        return null;
      }
    },
    metaData: {
      type: Array,
      default(){
        return [];
      }
    },
    legacyMetaData: {
      type: Object,
      default(){
        return {};
      }
    },
    useViewArPersonalized: {
      type: [Boolean, String, Number],
      default(){
        return false;
      }
    },
    arDisplay: {
      type: Object,
      default(){
        return { show360: true, showRoom: true, bgColor: null };
      }
    }
  },
  watch: {
    open3d(value){
      if(value){
        this.loadingScriptModelViewer();
      }
    },
    uuidAr(value){
      if(value){
        this.open3d = false;
        this.openImg = false;
      }
    },
    resolvedArResult: {
      immediate: true,
      handler(entry){
        if(!entry){
          this.open3d = false;
          this.openImg = false;
        }
        this.urlGLT = (entry && entry.glbUrl) || '';
        this.urlIMG = (entry && (entry.previewCardUrl || entry.previewImageUrl)) || '';
        this.link_3d_mobile = (entry && entry.viewUrl) || '';
      }
    },
    personalized(value){
      if(this.isPersonalizedArMode && (this.open3d || this.openImg)){

        this.open3d = false;
        this.openImg = false;
      }
    },
    currentSizeKey(newSizeKey, oldSizeKey){
      if(!this.isPersonalizedArMode || newSizeKey === oldSizeKey){
        return;
      }
      const wasViewingRoom = this.openImg;
      const wasViewingAr = this.open3d;
      // Khách chưa mở AR: không tạo sẵn. Tạo sẵn = chụp artwork 2000px +
      // upload ~4,5MB lên AR service ngay lúc tải trang / mỗi lần đổi size,
      // làm trang chậm thêm ~1-2s. AR sẽ được tạo khi khách bấm nút.
      if(!wasViewingRoom && !wasViewingAr){
        return;
      }
      this.openImg = false;
      this.open3d = false;
      this.personalizedError = null;
      if(wasViewingRoom){
        this.generatingRoom = true;
      }
      if(wasViewingAr){
        this.generatingAr = true;
      }
      const requestedSizeKey = newSizeKey;
      this.generatePersonalizedArResult()
        .then(entry => {
          if(this.currentSizeKey !== requestedSizeKey){
            return;
          }
          if(wasViewingRoom){
            this.applyRoomResult(entry);
          }
          if(wasViewingAr){
            this.applyArResult(entry);
          }
        })
        .catch(err => {
          if(this.currentSizeKey !== requestedSizeKey){
            return;
          }
          this.personalizedError = friendlyArErrorMessage(err);
        })
        .finally(() => {
          if(this.currentSizeKey !== requestedSizeKey){
            return;
          }
          if(wasViewingRoom){
            this.generatingRoom = false;
          }
          if(wasViewingAr){
            this.generatingAr = false;
          }
        });
    },
    isGeneratingPersonalized(isGenerating){
      if(isGenerating){
        this.loadingMessageIndex = 0;
        this.loadingMessageTimer = setInterval(() => {
          this.loadingMessageIndex = (this.loadingMessageIndex + 1) % this.loadingMessages.length;
        }, GENERATING_MESSAGE_INTERVAL_MS);
      } else if(this.loadingMessageTimer){
        clearInterval(this.loadingMessageTimer);
        this.loadingMessageTimer = null;
      }
    }
  },
  components: {
    ModelViewerAr,
    'artwork-preview': ArtworkPreview
  },
  provide() {
    this.captureImageTracker = createCaptureImageTracker();
    return { previewImageTracker: this.captureImageTracker };
  },
  mounted() {

  },
  computed: {
    ...mapGetters(['platform', 'product', 'selectedVariant', 'artworks', 'personalized', 'variants']),
    currentVariant(){
      const { product, selectedVariant } = this;
      if(!product || !Array.isArray(product.variants) || !selectedVariant){
        return null;
      }
      return product.variants.find(v => v.id && v.id.toString() === selectedVariant.toString()) || null;
    },
    currentSizeLabel(){
      const { platform, product, currentVariant } = this;
      if(!currentVariant){
        return null;
      }
      if(platform === 'woocommerce'){
        const attributes = Array.isArray(currentVariant.attributes) ? currentVariant.attributes : [];
        const sizeAttribute = attributes.find(a => String(a.name || '').trim().toLowerCase() === 'size');
        return sizeAttribute ? sizeAttribute.option : null;
      }
      if(platform === 'shopify'){
        const options = (product && Array.isArray(product.options)) ? product.options : [];
        const index = options.findIndex(o => String(o.name || '').trim().toLowerCase() === 'size');
        if(index === -1){
          return null;
        }
        return currentVariant[`option${index + 1}`] || null;
      }
      return null;
    },
    matchedArResult(){
      const { metaData, currentSizeLabel } = this;
      if(!Array.isArray(metaData) || metaData.length === 0){
        return null;
      }
      if(!currentSizeLabel){
        return metaData[0];
      }
      const parsedSize = parseSizeLabel(currentSizeLabel);
      if(!parsedSize){
        return metaData[0];
      }
      const sizeKey = `${parsedSize.w}x${parsedSize.h}`;
      return metaData.find(r => r.size === sizeKey || r.size === `${sizeKey}in`) || metaData[0];
    },
    hasAbnviewerResults(){
      return Array.isArray(this.metaData) && this.metaData.length > 0;
    },
    legacyArResult(){
      const { legacyMetaData } = this;
      const glb_url = legacyMetaData && legacyMetaData.glb_url;
      const img_url = legacyMetaData && legacyMetaData.img_url;
      const link_3d_mobile = legacyMetaData && legacyMetaData.link_3d_mobile;
      if(!glb_url && !img_url && !link_3d_mobile){
        return null;
      }
      return {
        glbUrl: glb_url || '',
        previewCardUrl: img_url || '',
        viewUrl: link_3d_mobile || ''
      };
    },
    resolvedArResult(){
      if(this.isPersonalizedArMode){
        return null;
      }
      if(this.hasAbnviewerResults){
        return this.matchedArResult;
      }
      return this.legacyArResult;
    },
    isGeneratingPersonalized(){
      return this.generatingRoom || this.generatingAr;
    },
    isPersonalizedArMode(){
      const { useViewArPersonalized } = this;
      return useViewArPersonalized === true || useViewArPersonalized === 'true' || useViewArPersonalized === '1' || useViewArPersonalized === 1;
    },
    currentSizeKey(){
      const parsed = parseSizeLabel(this.currentSizeLabel);
      return parsed ? `${parsed.w}x${parsed.h}` : null;
    },
    productSku(){
      const { currentVariant, product } = this;
      return (currentVariant && currentVariant.sku) || (product && product.sku) || '';
    },
    ornamentMaterial(){
      return detectOrnamentMaterialFromSku(this.productSku);
    },
    isOrnamentProduct(){
      return !!this.ornamentMaterial;
    },
    // Gửi JPEG (nhẹ hơn PNG ~5-10 lần) chỉ cho loại mà server luôn ép nền trắng
    // rồi lưu JPEG: canvas, mug, pillow, blanket, jewelry dish, ornament gốm.
    // Glass/wood ornament, acrylic, stone, ceramic tile, bamboo dùng kênh alpha
    // (cắt hình / nền riêng) nên phải giữ PNG.
    arUploadAsJpeg(){
      if(this.isOrnamentProduct){
        return this.ornamentMaterial === 'ceramic' || this.ornamentMaterial === 'ceramicHeart';
      }
      return !(this.isStoneProduct || this.isCeramicTileProduct || this.isAcrylicPlaqueProduct || this.isBambooCuttingBoardProduct);
    },
    productTitle(){
      const { product } = this;
      return (product && (product.name || product.title)) || '';
    },
    isMugProduct(){
      return !this.isOrnamentProduct && String(this.productTitle).toLowerCase().includes('mug');
    },
    parentProductSku(){
      const { product } = this;
      return (product && product.sku) || '';
    },
    jewelryDishShape(){
      const { product } = this;
      return detectJewelryDishShapeFromVariants(product && product.variants);
    },
    isJewelryDishProduct(){
      return !this.isOrnamentProduct && !this.isMugProduct && !!this.jewelryDishShape;
    },
    stoneShape(){
      return detectStoneShapeFromSku(this.parentProductSku);
    },
    isStoneProduct(){
      return !this.isOrnamentProduct && !this.isMugProduct && !this.isJewelryDishProduct && !!this.stoneShape;
    },
    ceramicTileShape(){
      return detectCeramicTileShapeFromSku(this.parentProductSku);
    },
    isCeramicTileProduct(){
      return !this.isOrnamentProduct && !this.isMugProduct && !this.isJewelryDishProduct &&
        !this.isStoneProduct && !!this.ceramicTileShape;
    },
    isBambooCuttingBoardProduct(){
      return !this.isOrnamentProduct && !this.isMugProduct && !this.isJewelryDishProduct &&
        !this.isStoneProduct && !this.isCeramicTileProduct &&
        this.parentProductSku.toLowerCase().includes(BAMBOO_CUTTING_BOARD_SKU_MARKER);
    },
    acrylicPlaqueShape(){
      return detectAcrylicPlaqueShapeFromSku(this.parentProductSku);
    },
    isAcrylicPlaqueProduct(){
      return !this.isOrnamentProduct && !this.isMugProduct && !this.isJewelryDishProduct &&
        !this.isStoneProduct && !this.isCeramicTileProduct && !this.isBambooCuttingBoardProduct &&
        !!this.acrylicPlaqueShape;
    },
    // Pillow is the odd one out again (like Jewelry Dish): detected by
    // scanning every variant's own sku (not the parent product's) for
    // "Pillow" + a WxH size, shape derived from comparing width vs height.
    pillowShape(){
      const { product } = this;
      return detectPillowShapeFromVariants(product && product.variants);
    },
    isPillowProduct(){
      return !this.isOrnamentProduct && !this.isMugProduct && !this.isJewelryDishProduct &&
        !this.isStoneProduct && !this.isCeramicTileProduct && !this.isBambooCuttingBoardProduct &&
        !this.isAcrylicPlaqueProduct && !!this.pillowShape;
    },
    isBlanketProduct(){
      return !this.isOrnamentProduct && !this.isMugProduct && !this.isJewelryDishProduct &&
        !this.isStoneProduct && !this.isCeramicTileProduct && !this.isBambooCuttingBoardProduct &&
        !this.isAcrylicPlaqueProduct && !this.isPillowProduct &&
        this.parentProductSku.toLowerCase().includes(BLANKET_SKU_MARKER);
    },
    effectiveArSizeKey(){
      if(this.isOrnamentProduct){
        return ORNAMENT_SIZE;
      }
      if(this.isMugProduct){
        return MUG_SIZE;
      }
      if(this.isJewelryDishProduct){
        return this.jewelryDishShape;
      }
      if(this.isStoneProduct){
        return this.stoneShape;
      }
      if(this.isCeramicTileProduct){
        return this.ceramicTileShape;
      }
      if(this.isAcrylicPlaqueProduct){
        return this.acrylicPlaqueShape;
      }
      if(this.isBambooCuttingBoardProduct){
        return BAMBOO_CUTTING_BOARD_SIZE;
      }
      if(this.isPillowProduct){
        return this.pillowShape;
      }
      if(this.isBlanketProduct){
        // "50x60 inches" -> "50x60": the AR shows the size the customer picked.
        return this.currentSizeKey || DEFAULT_BLANKET_SIZE;
      }
      return this.currentSizeKey;
    },
    show360(){
      return !this.arDisplay || this.arDisplay.show360 !== false;
    },
    showRoom(){
      return !this.arDisplay || this.arDisplay.showRoom !== false;
    },
    threedBackgroundStyle(){
      // A color picked on the product edit screen wins; otherwise glass
      // ornaments keep their black background.
      if(this.arDisplay && this.arDisplay.bgColor){
        return {
          backgroundColor: this.arDisplay.bgColor
        };
      }
      if(this.ornamentMaterial !== 'glass'){
        return {};
      }
      return {
        backgroundColor: '#000'
      };
    },
    roomBackgroundStyle(){
      if(this.arDisplay && this.arDisplay.bgColor){
        return {
          backgroundColor: this.arDisplay.bgColor
        };
      }
      return {};
    },
    // Mirrors PrintArea.vue's own artwork resolution: match a print area's
    // artwork_id across every (campaign) variant's print_areas, rather than
    // assuming there's exactly one artwork sitting at artworks[0] — a
    // product can have more than one artwork, and array order from the API
    // isn't guaranteed to put "the" one actually used by its mockup first.
    // Falls back to artworks[0] only if nothing in print_areas matches, so
    // products that already worked keep working.
    currentArtwork(){
      const { artworks, variants } = this;
      if(!Array.isArray(artworks) || artworks.length === 0){
        return null;
      }
      if(Array.isArray(variants)){
        for(const variant of variants){
          const printAreas = Array.isArray(variant.print_areas) ? variant.print_areas : [];
          for(const printArea of printAreas){
            const match = artworks.find(a => a.id === printArea.artwork_id);
            if(match){
              return match;
            }
          }
        }
      }
      return artworks[0];
    },
    artworkPersonalizationSignature(){
      const { personalized, currentArtwork } = this;
      if(!currentArtwork){
        return '';
      }
      try {
        return JSON.stringify((personalized && personalized[currentArtwork.id]) || null);
      } catch (err) {
        return '';
      }
    },
    captureArtworkWidth(){
      const { currentArtwork } = this;
      if(!currentArtwork || !currentArtwork.width){
        return 0;
      }
      return Math.min(currentArtwork.width, MAX_CAPTURE_DIMENSION);
    },
    captureStageConfig(){
      const { currentArtwork, captureArtworkWidth } = this;
      if(!currentArtwork || !captureArtworkWidth || !currentArtwork.height){
        return { width: 1, height: 1 };
      }
      return {
        width: captureArtworkWidth,
        height: Math.round(captureArtworkWidth * (currentArtwork.height / currentArtwork.width))
      };
    }
  },
  methods: {
    async captureCurrentArtworkCanvas(){
      if(!this.currentArtwork){
        return null;
      }
      if(!this.captureStageActive){
        // Stage mới dựng lại từ đầu: bỏ các ảnh còn treo của stage cũ đã gỡ.
        this.captureImageTracker.reset();
        this.captureStageActive = true;
        this.captureStageMountedAt = Date.now();
      }
      this.captureStageUsers++;
      try {
        await this.$nextTick();
        if(this.captureStageMountedAt){
          const elapsedSinceMount = Date.now() - this.captureStageMountedAt;
          const remaining = TEXT_LAYER_READY_DELAY_MS - elapsedSinceMount;
          if(remaining > 0){
            await new Promise(resolve => setTimeout(resolve, remaining));
          }
        }
        await waitForCaptureImages(this.captureImageTracker);
        await new Promise(resolve => setTimeout(resolve, 200));
        const stageComponent = this.$refs.captureStage;
        const stage = stageComponent && stageComponent.getNode ? stageComponent.getNode() : null;
        if(!stage){
          return null;
        }
        return stage.toCanvas({ pixelRatio: 1 });
      } finally {
        // Chụp xong thì gỡ stage: để lại thì mỗi lần khách sửa chữ, trang lại
        // vẽ thêm bản artwork 2000px ở nền.
        this.captureStageUsers--;
        if(this.captureStageUsers === 0){
          this.captureStageActive = false;
          this.captureStageMountedAt = null;
        }
      }
    },
    async generatePersonalizedArResult(){
      const {
        isOrnamentProduct, ornamentMaterial,
        isMugProduct,
        isJewelryDishProduct, jewelryDishShape,
        isStoneProduct, stoneShape,
        isCeramicTileProduct, ceramicTileShape,
        isAcrylicPlaqueProduct, acrylicPlaqueShape,
        isBambooCuttingBoardProduct,
        isPillowProduct, pillowShape,
        isBlanketProduct
      } = this;
      const sizeKey = this.effectiveArSizeKey;
      if(!sizeKey){
        throw new Error('Could not determine the selected size.');
      }
      const signature = this.artworkPersonalizationSignature;
      if(this.personalizedCache.signature !== signature){
        this.personalizedCache = { signature, bySize: {} };
        this.personalizedInFlight = {};
      }
      const cached = this.personalizedCache.bySize[sizeKey];
      if(cached){
        return cached;
      }
      if(this.personalizedInFlight[sizeKey]){
        return this.personalizedInFlight[sizeKey];
      }
      const requestPromise = (async () => {
        const canvas = await this.captureCurrentArtworkCanvas();
        if(!canvas){
          throw new Error('Could not capture the current artwork image.');
        }
        const asJpeg = this.arUploadAsJpeg;
        const formData = new FormData();
        if(isMugProduct){
          const { front, back } = splitCanvasInHalf(canvas);
          const [frontFile, backFile] = await Promise.all([
            encodeArtworkFile(front, 'artwork-front', asJpeg),
            encodeArtworkFile(back, 'artwork-back', asJpeg)
          ]);
          formData.append('image', frontFile);
          formData.append('backImage', backFile);
        } else {
          formData.append('image', await encodeArtworkFile(canvas, 'artwork', asJpeg));
        }
        formData.append('sizes', sizeKey);
        formData.append('placement', 'floor');
        formData.append('siteLogo', '');
        formData.append('storage_type', 'temporary');
        if(isOrnamentProduct){
          formData.append('productType', 'ornament');
          formData.append('ornamentMaterial', ornamentMaterial);
        } else if(isMugProduct){
          formData.append('productType', 'mug');
        } else if(isJewelryDishProduct){
          formData.append('productType', 'jewelryDish');
          formData.append('dishShape', jewelryDishShape);
        } else if(isStoneProduct){
          formData.append('productType', 'stone');
          formData.append('stoneShape', stoneShape);
        } else if(isCeramicTileProduct){
          formData.append('productType', 'ceramicTile');
          formData.append('ceramicTileShape', ceramicTileShape);
        } else if(isAcrylicPlaqueProduct){
          formData.append('productType', 'acrylicPlaque');
          formData.append('acrylicPlaqueShape', acrylicPlaqueShape);
        } else if(isBambooCuttingBoardProduct){
          formData.append('productType', 'bambooCuttingBoard');
        } else if(isPillowProduct){
          formData.append('productType', 'pillow');
          formData.append('pillowShape', pillowShape);
        } else if(isBlanketProduct){
          formData.append('productType', 'blanket');
        }
        // Dịch vụ AR treo thì không để nút quay mãi.
        const controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
        const timeoutId = controller ? setTimeout(() => controller.abort(), AR_REQUEST_TIMEOUT_MS) : null;
        let data;
        try {
          const res = await fetch(`${AR_SERVICE_URL}/api/generate-ar`, {
            method: 'POST',
            headers: {
              'x-api-key': AR_SERVICE_API_KEY
            },
            body: formData,
            signal: controller ? controller.signal : undefined
          });
          if(!res.ok){
            throw new Error(`AR service error (HTTP ${res.status}).`);
          }
          data = await res.json();
        } catch(err) {
          if(err && err.name === 'AbortError'){
            const timeoutError = new Error(`AR service timed out after ${AR_REQUEST_TIMEOUT_MS}ms.`);
            timeoutError.isTimeout = true;
            throw timeoutError;
          }
          throw err;
        } finally {
          if(timeoutId){
            clearTimeout(timeoutId);
          }
        }
        const entry = data && Array.isArray(data.results) ? data.results[0] : null;
        if(!entry || (!entry.glbUrl && !entry.viewUrl)){
          throw new Error((entry && entry.error) || 'AR service returned no result.');
        }
        this.personalizedCache.bySize[sizeKey] = entry;
        return entry;
      })();
      this.personalizedInFlight[sizeKey] = requestPromise;
      try {
        return await requestPromise;
      } finally {
        delete this.personalizedInFlight[sizeKey];
      }
    },
    applyRoomResult(entry, popup = null){
      if(isMobileDevice() && entry.viewUrl){
        if(popup && !popup.closed){
          popup.location.href = entry.viewUrl;
          return;
        }
        window.open(entry.viewUrl, '_blank', 'noopener');
        return;
      }
      if(popup && !popup.closed){
        popup.close();
      }
      const previewUrl = entry.previewCardUrl || entry.previewImageUrl || '';
      if(!previewUrl){
        throw new Error('AR service did not return a preview image.');
      }
      this.urlIMG = previewUrl;
      this.open3d = false;
      this.openImg = true;
    },
    applyArResult(entry){
      if(!entry.glbUrl){
        throw new Error('AR service did not return a 3D model.');
      }
      this.urlGLT = entry.glbUrl;
      this.openImg = false;
      this.open3d = true;
    },
    async handleClickRoomPersonalized(){
      if(this.openImg){
        this.openImg = false;
        return;
      }
      if(this.generatingRoom || this.generatingAr){
        return;
      }
      const requestedSizeKey = this.currentSizeKey;
      this.personalizedError = null;
      this.generatingRoom = true;
      // Mobile mở AR ở tab mới. Phải mở tab ngay trong lúc bấm: chờ tạo AR
      // (vài giây) xong mới window.open thì Safari/Chrome mobile chặn popup.
      const popup = isMobileDevice() ? openPendingArWindow() : null;
      try {
        const entry = await this.generatePersonalizedArResult();
        if(this.currentSizeKey !== requestedSizeKey){
          closeWindow(popup);
          return;
        }
        this.applyRoomResult(entry, popup);
      } catch(err) {
        closeWindow(popup);
        if(this.currentSizeKey === requestedSizeKey){
          this.personalizedError = friendlyArErrorMessage(err);
        }
      } finally {
        if(this.currentSizeKey === requestedSizeKey){
          this.generatingRoom = false;
        }
      }
    },
    async handleClickArPersonalized(){
      if(this.open3d){
        this.open3d = false;
        return;
      }
      if(this.generatingRoom || this.generatingAr){
        return;
      }
      const requestedSizeKey = this.currentSizeKey;
      this.personalizedError = null;
      this.generatingAr = true;
      try {
        const entry = await this.generatePersonalizedArResult();
        if(this.currentSizeKey !== requestedSizeKey){
          return;
        }
        this.applyArResult(entry);
      } catch(err) {
        if(this.currentSizeKey === requestedSizeKey){
          this.personalizedError = friendlyArErrorMessage(err);
        }
      } finally {
        if(this.currentSizeKey === requestedSizeKey){
          this.generatingAr = false;
        }
      }
    },
    handleToggleViewImage(){
      this.openImg = !this.openImg;
      if(this.openImg){
        this.open3d = false;
      }
    },
    handleToggleViewAR() {
      this.open3d = !this.open3d;
      if(this.open3d){
        this.openImg = false;
      }
    },
    loadingScriptModelViewer() {
      if(this.modelViewerRequested){
        return;
      }
      this.modelViewerRequested = true;
      this.loading = true;
      const THIS = this;
      const modelViewer = document.createElement('script');
      modelViewer.setAttribute(
        'src',
        'https://ajax.googleapis.com/ajax/libs/model-viewer/4.0.0/model-viewer.min.js'
      );
      modelViewer.setAttribute('type', 'module');
      modelViewer.async = true;
      document.head.appendChild(modelViewer);
      setTimeout(() => {
        THIS.loadJs = true;
        THIS.loading = false;
      }, 1000);
    }
  },
  created() {
    // model-viewer (~956KB) chỉ cần khi khách mở xem 3D — xem watcher open3d.
  },
  beforeDestroy() {
    if(this.loadingMessageTimer){
      clearInterval(this.loadingMessageTimer);
    }
  }
}
</script>

<style>
model-viewer {
  width: 100%;
  aspect-ratio: 1 / 1;
  height: 100%;
}
.model-viewer-container.threed{
  background-image: url(https://m106v206c3.execute-api.ap-southeast-2.amazonaws.com//200/5cdb50f0-b385-11ef-a3e4-4e5b5c96fb45__360-degrees.png);
  background-size: 60px auto;
  background-position: left 20px top 20px;
  background-repeat: no-repeat;
}
.model-viewer-container {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #e9e9e9;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
.model-viewer-container__loading {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 25px;
  color: #424242;
}
.model-viewer-container__image_ar_qr {
  height: 100%;
}
.action_viewer_ar_product__box_btn.open {
  height: 35px;
  width: 35px;
  aspect-ratio: 1 / 1;
  min-width: 35px;
  max-width: 35px;
  min-height: 35px;
  max-height: 35px;
}
.link_3d_mobile{
  text-decoration: none;
  display: none;
}
@media (max-width: 849px) {
  .action_viewer_ar_product__box_btn.view_in_room{
    display: none;
  }
  .link_3d_mobile{
    display: block;
  }
}
.ar_personalized_spinner {
  display: inline-block;
  width: 14px;
  height: 14px;
  border: 2px solid rgba(51, 51, 51, 0.25);
  border-top-color: #333;
  border-radius: 50%;
  animation: ar_personalized_spin 0.8s linear infinite;
}
@keyframes ar_personalized_spin {
  to {
    transform: rotate(360deg);
  }
}
.ar_personalized_error {
  position: absolute;
  bottom: 50px;
  right: 10px;
  max-width: 220px;
  padding: 6px 10px;
  background: #fff3f3;
  border: 1px solid #f5a3a3;
  color: #b40000;
  font-size: 12px;
  border-radius: 6px;
  z-index: 1000;
}
.ar_generating_overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 20px;
  text-align: center;
  background: rgba(255, 255, 255, 0.88);
  backdrop-filter: blur(2px);
  z-index: 500;
}
.ar_generating_overlay__animation {
  position: relative;
  width: 70px;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.ar_generating_overlay__frame {
  font-size: 44px;
  display: inline-block;
  animation: ar_generating_bounce 1.3s ease-in-out infinite;
}
.ar_generating_overlay__sparkle {
  position: absolute;
  top: -2px;
  right: 4px;
  font-size: 20px;
  animation: ar_generating_sparkle 1.3s ease-in-out infinite;
}
@keyframes ar_generating_bounce {
  0%, 100% {
    transform: translateY(0) rotate(-4deg);
  }
  50% {
    transform: translateY(-10px) rotate(4deg);
  }
}
@keyframes ar_generating_sparkle {
  0%, 100% {
    opacity: 0.35;
    transform: scale(0.8) rotate(0deg);
  }
  50% {
    opacity: 1;
    transform: scale(1.15) rotate(25deg);
  }
}
.ar_generating_overlay__text {
  font-size: 15px;
  font-weight: 600;
  font-family: system-ui;
  color: #333;
  max-width: 260px;
  min-height: 20px;
}
.ar_fade-enter-active,
.ar_fade-leave-active {
  transition: opacity 0.3s;
}
.ar_fade-enter,
.ar_fade-leave-to {
  opacity: 0;
}
.ar_generating_overlay__dots {
  display: flex;
  gap: 6px;
}
.ar_generating_overlay__dots span {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #d26e4b;
  display: inline-block;
  animation: ar_generating_dot_bounce 1s ease-in-out infinite;
}
.ar_generating_overlay__dots span:nth-child(2) {
  animation-delay: 0.15s;
}
.ar_generating_overlay__dots span:nth-child(3) {
  animation-delay: 0.3s;
}
@keyframes ar_generating_dot_bounce {
  0%, 80%, 100% {
    transform: scale(0.6);
    opacity: 0.5;
  }
  40% {
    transform: scale(1);
    opacity: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Media/LoadArThree.vue